import { useRef } from 'react';
import { nanoid } from '@reduxjs/toolkit';

const useRandomIdFallback = (randomId?: string) => {
  const idRef = useRef<string | undefined>(randomId);

  if (!idRef.current) {
    idRef.current = nanoid();
  }

  return idRef.current;
};

export default useRandomIdFallback;
